export default __webpack_public_path__ + "static/Plots0006-3087c0881b5e3cbef451e2946c0c9d95.jpg";